/**
 * SEO helpers: private route detection and brand/model slugs.
 * Keep PRIVATE_ROUTE_PREFIXES in sync with Disallow rules in public/robots.txt.
 */

export const SITE_URL = "https://hittadelar.se";

/** Routes that must never be indexed (login, account, chat, purchase, admin). */
export const PRIVATE_ROUTE_PREFIXES = [
  "/auth",
  "/request-password-reset",
  "/reset-password",
  "/dashboard",
  "/profile",
  "/settings",
  "/saved",
  "/account",
  "/messages",
  "/chat",
  "/purchases",
  "/review",
  "/checkout",
  "/create-listing",
  "/edit-listing",
  "/admin",
  "/security-monitor",
  "/.lovable",
];

export const isPrivateRoute = (pathname: string) =>
  PRIVATE_ROUTE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));

/** "Volkswagen Golf" -> "volkswagen-golf", å/ä/ö -> a/a/o */
export const toSlug = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[åä]/g, "a")
    .replace(/ö/g, "o")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const brandPath = (brand: string) => `/bildelar/${toSlug(brand)}`;
export const modelPath = (brand: string, model: string) =>
  `/bildelar/${toSlug(brand)}/${toSlug(model)}`;
